import './BetbookTopEvents.less';

import i18n from '@i18n';
import moment from 'moment';
import React, { useEffect } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';
import BetLocationContext, { betLocation } from 'nike-ui/src/common/BetLocationContext';

import BetbookDetailHeaderSimplified from '@/betbook/views/BetbookDetailHeaderSimplified';
import TopEventBox from '@/betbook/views/TopEventBox';
import BetbookTopEventsFilter from '@/betbook/views/BetbookTopEventsFilter';
import BlockLoader from '@/ui/BlockLoader';
import { getConfigProperty } from '@/common/oldMobile';
import { TIME_TODAY, TIME_TOMORROW } from 'nike-ui/src/components/betbook/constants';

import { fetchTopEventsData, setTopEventsDateFilter, setTopEventsSportFilter } from '@/betbook/handlers';

import { top10ActiveTab$, top10LiveBets$, top10PrematchBets$ } from 'nike-ui/src/components/homepage/subs';
import {
    betbookTopEventsData$,
    betbookTopEventsMatches$,
    topEventsFilterByDate$,
    topEventsFilterBySport$
} from 'nike-ui/src/components/betbook/subs.js';
import { TOP10_LIVE_TAB } from 'nike-ui/src/components/homepage/constants';
import { useFetchMatchesFromTopEvents } from 'nike-ui/src/components/homepage/hooks';
import { topEventsBetbookMatchesLoaded } from 'nike-ui/src/components/homepage/handlers';
import { useScoreboardTypes } from 'nike-ui/src/components/turboLive/hooks/useScoreboardTypes';
import { ErrorBoundary } from 'nike-ui/src/common/ErrorBoundary';

function BetbookTopEvents({ sport, time }) {
    const { subscribe } = useReframe();
    const dateFilter = subscribe(topEventsFilterByDate$) || time;
    const sportFilter = subscribe(topEventsFilterBySport$) || sport;
    const description = i18n('betbook.topEvents.description');

    useFetchMatchesFromTopEvents(topEventsBetbookMatchesLoaded, betbookTopEventsData$, betbookTopEventsMatches$);

    function returnDateTimeFromConst(time) {
        if (time === TIME_TODAY) return moment().format('YYYY-MM-DD');
        if (time === TIME_TOMORROW)
            return moment()
                .add(1, 'days')
                .format('YYYY-MM-DD');
        return null;
    }

    useEffect(() => {
        dispatch(setTopEventsDateFilter(time));
        dispatch(setTopEventsSportFilter(sport));
    }, [sport, time]);

    useEffect(() => {
        fetchTopEventsData(returnDateTimeFromConst(dateFilter), sportFilter);
    }, [dateFilter, sportFilter]);

    return (
        <BetLocationContext.Provider value={{ betLocationSection: betLocation.BETBOOK_TOP20 }}>
            <BetbookDetailHeaderSimplified
                title={i18n('betbook.topEvents.title', getConfigProperty('betbook.topEventsLimit'))}
            />
            <div className="flex flex-col justify-start items-center">
                <div className="flex flex-center fs-14 px-20 py-30 text-center c-black-70">{description}</div>
                <BetbookTopEventsFilter />
                <TopEventsBoxes isBetbook />
            </div>
        </BetLocationContext.Provider>
    );
}

export const TopEventsBoxes = ({ dataAtid, isBetbook = false }) => (
    <ErrorBoundary description={TopEventsBoxes}>
        <TopEventsBoxesView dataAtid={dataAtid} isBetbook={isBetbook} />
    </ErrorBoundary>
);

function TopEventsBoxesView({ dataAtid, isBetbook = false }) {
    const { subscribe } = useReframe();
    useScoreboardTypes();
    const showLiveEvents = subscribe(top10ActiveTab$) === TOP10_LIVE_TAB;
    // if used in betbook sub to betbookTopEventsData, otherwise used on homepage
    const topEventsSelections =
        (isBetbook && subscribe(betbookTopEventsData$)) ||
        (showLiveEvents ? subscribe(top10LiveBets$) : subscribe(top10PrematchBets$));
    const noDataWithFilterMsg = i18n('betbook.topEvents.errorMessage');

    if (!topEventsSelections) {
        return (
            <div className="flex flex-center flex-1">
                <BlockLoader />
            </div>
        );
    }
    if (topEventsSelections?.length === 0) {
        return (
            <div className="flex no-data-message fs-14 flex-center ">
                <span className="br-b-default-light py-5 px-5 text-bold">{noDataWithFilterMsg}</span>
            </div>
        );
    }
    return (
        <div className="py-20 flex flex-col flex-gap-10 bg-light-burgundy">
            {topEventsSelections?.map((row, index) => (
                <TopEventBox
                    dataAtid={dataAtid}
                    index={index}
                    isLiveEvent={showLiveEvents && !isBetbook}
                    key={index}
                    matchInfo={row}
                />
            ))}
        </div>
    );
}

export default BetbookTopEvents;
